<p-dialog
  [visible]="visible"
  (visibleChange)="onRequestDialogVisibilityChange($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  styleClass="request-access-dialog"
>
  <div class="request-access-container">
    <div class="dialog-top-section">
      <div class="logo-wrapper">
        <img
          src="assets/images/aipho-logo-black.svg"
          alt="AI-PHO"
          class="dialog-logo"
        />
      </div>

      <button type="button" class="close-btn" (click)="closeRequestDialog()">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <h2 class="dialog-title">{{ title }}</h2>

    <form [formGroup]="requestAccessForm">
      <div class="field-wrapper">
        <label class="field-label">
          ABInBev Official Email<span class="required">*</span>
        </label>

        <input
          pInputText
          formControlName="email"
          placeholder="Enter ABInBev Official Email"
          class="custom-input"
          [class.invalid-field]="hasError('email')"
        />
        @if (hasError("email")) {
          <small class="field-error">{{ getErrorMessage("email") }}</small>
        }
      </div>

      <div class="field-wrapper">
        <label class="field-label"> Zone<span class="required">*</span> </label>

        <app-dynamic-dropdown
          class="request-dynamic-dropdown"
          formControlName="zones"
          [options]="zoneOptions"
          [optionLabel]="'name'"
          [optionValue]="'value'"
          [label]="'Select Zone'"
          [isMultiSelect]="false"
          [filter]="true"
          [loading]="zonesLoading"
        >
        </app-dynamic-dropdown>
        @if (hasError("zones")) {
          <small class="field-error">{{ getErrorMessage("zones") }}</small>
        }
      </div>

      <div class="field-wrapper">
        <label class="field-label">
          Country(s)<span class="required">*</span>
        </label>

        <app-dynamic-dropdown
          class="request-dynamic-dropdown"
          formControlName="countries"
          [options]="countryOptions"
          [optionLabel]="'name'"
          [optionValue]="'value'"
          [label]="'Select Country(s)'"
          [isMultiSelect]="true"
          [filter]="true"
          [loading]="countriesLoading"
          [disabled]="!requestAccessForm.get('zones')?.value"
        >
        </app-dynamic-dropdown>
        @if (hasError("countries")) {
          <small class="field-error">{{ getErrorMessage("countries") }}</small>
        }
      </div>

      <div class="action-buttons">
        @if (submitError) {
          <small class="submit-error">{{ submitError }}</small>
        }

        <button
          pButton
          type="button"
          label="Cancel"
          class="cancel-btn"
          [disabled]="submitting"
          (click)="closeRequestDialog()"
        ></button>

        <button
          pButton
          type="button"
          [label]="submitting ? '' : 'Send Request'"
          [attr.aria-label]="submitting ? 'Sending...' : 'Send Request'"
          class="submit-btn"
          [disabled]="submitting"
          [loading]="submitting"
          (click)="submitRequest()"
        ></button>
      </div>
    </form>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="showSuccessDialog"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '520px' }"
  styleClass="aipho-success-dialog"
>
  <div class="success-dialog-content">
    <img
      src="assets/images/aipho-logo-black.svg"
      alt="AIPHO Logo"
      class="logo"
    />

    <h2>
      {{
        showWelcomeMessage
          ? "Welcome to AIPHO Access Portal"
          : "Access Request Submitted"
      }}
    </h2>

    <p>Your request has been submitted successfully.</p>
  </div>
</p-dialog>
